export default "__VITE_ASSET__b83bc78a__"